// extracted by mini-css-extract-plugin
export default {"iconBox":"Hf452jWqDkLrlAqCwiYJ"};